import { apiClient } from '_app'
import {
  ApiResponse,
  BondPolicyNumberDto,
  PortOfEntryDto,
  PortOfLadingDto,
  SettingsAutoArchiveAfterImportCancellationDateDto,
  SettingsBondPolicyDto,
  SettingsMichiganTitleFeeDto,
  SettingsMissingOhioTitleAlertDto,
  QuickBooksSyncBootstrapDto,
  QuickBooksSyncDto,
  QuickBooksSyncUploadDto,
  SettingsReadyForOutboundDateInformationDto,
  SettingsVehicleReleaseDateInformationDto
} from 'dtos'
import { BondPolicyNumbersParameters, PortOfEntryParameters, PortOfLadingParameters } from 'parameters'
import { objectToFormData, URIQuery } from 'utils'

export const getAutoArchiveAfterImportCancellationDateInformation = () =>
  apiClient
    .get<ApiResponse<SettingsAutoArchiveAfterImportCancellationDateDto>>(
      '/api/settings/auto-archive-after-import-cancellation-date-information'
    )
    .then(({ data }) => data)

export const updateAutoArchiveAfterImportCancellationDateInformation = (
  values: SettingsAutoArchiveAfterImportCancellationDateDto
) =>
  apiClient
    .put<ApiResponse<SettingsAutoArchiveAfterImportCancellationDateDto>>(
      '/api/settings/auto-archive-after-import-cancellation-date-information',
      values
    )
    .then(res => res.data)
    .catch(reason => {
      throw new Error(reason)
    })

export const getMissingOhioTitleAlertDate = () =>
  apiClient
    .get<ApiResponse<SettingsMissingOhioTitleAlertDto>>('/api/settings/missing-ohio-title-alert-date-information')
    .then(({ data }) => data)

export const updateMissingOhioTitleAlertDate = (values: SettingsMissingOhioTitleAlertDto) =>
  apiClient
    .put<ApiResponse<SettingsMissingOhioTitleAlertDto>>('/api/settings/missing-ohio-title-alert-date-information', values)
    .then(res => res.data)
    .catch(reason => {
      throw new Error(reason)
    })

export const getReadyForOutboundDateInformation = () =>
  apiClient
    .get<ApiResponse<SettingsReadyForOutboundDateInformationDto>>('/api/settings/ready-for-outbound-date-information')
    .then(({ data }) => data)

export const updateReadyForOutboundDateInformation = (values: SettingsReadyForOutboundDateInformationDto) =>
  apiClient
    .put<ApiResponse<SettingsReadyForOutboundDateInformationDto>>('/api/settings/ready-for-outbound-date-information', values)
    .then(res => res.data)
    .catch(reason => {
      throw new Error(reason)
    })

export const getVehicleReleaseDateInformation = () =>
  apiClient
    .get<ApiResponse<SettingsVehicleReleaseDateInformationDto>>('/api/settings/vehicle-release-date-information')
    .then(({ data }) => data)

export const updateVehicleReleaseDateInformation = (values: SettingsVehicleReleaseDateInformationDto) =>
  apiClient
    .put<ApiResponse<SettingsVehicleReleaseDateInformationDto>>('/api/settings/vehicle-release-date-information', values)
    .then(res => res.data)
    .catch(reason => {
      throw new Error(reason)
    })

export const getPortOfLading = (parameters: PortOfLadingParameters) =>
  apiClient
    .get<ApiResponse<PortOfLadingDto[]>>('/api/settings/ports-of-lading-maintenance' + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const createPortOfLading = (values: PortOfLadingDto) =>
  apiClient.post<ApiResponse<PortOfLadingDto>>('/api/settings/ports-of-lading-maintenance', values).then(res => res.data)

export const updatePortOfLading = (values: PortOfLadingDto) =>
  apiClient.put<ApiResponse<PortOfLadingDto>>('/api/settings/ports-of-lading-maintenance', values).then(res => res.data)

export const getPortOfEntry = (parameters: PortOfEntryParameters) =>
  apiClient
    .get<ApiResponse<PortOfEntryDto[]>>('/api/settings/ports-of-entry-maintenance' + URIQuery({ ...parameters }))
    .then(({ data }) => data)

export const createPortOfEntry = (values: PortOfEntryDto) =>
  apiClient.post<ApiResponse<PortOfEntryDto>>('/api/settings/ports-of-entry-maintenance', values).then(res => res.data)

export const updatePortOfEntry = (values: PortOfEntryDto) =>
  apiClient.put<ApiResponse<PortOfEntryDto>>('/api/settings/ports-of-entry-maintenance', values).then(res => res.data)

export const getBondPolicy = () =>
  apiClient.get<ApiResponse<SettingsBondPolicyDto>>('/api/settings/bond-policy').then(res => res.data)

export const updateBondPolicy = (values: SettingsBondPolicyDto) =>
  apiClient.put<ApiResponse<SettingsBondPolicyDto>>('/api/settings/bond-policy', values).then(res => res.data)

export const getBondPolicyNumbers = (parameters: BondPolicyNumbersParameters) =>
  apiClient
    .get<ApiResponse<BondPolicyNumberDto[]>>('/api/settings/bond-policy-numbers' + URIQuery({ ...parameters }))
    .then(res => res.data)

export const createBondPolicyNumber = (values: BondPolicyNumberDto) =>
  apiClient.post<ApiResponse<BondPolicyNumberDto>>('/api/settings/bond-policy-numbers', values).then(res => res.data)

export const updateBondPolicyNumber = (values: BondPolicyNumberDto) =>
  apiClient.put<ApiResponse<BondPolicyNumberDto>>('/api/settings/bond-policy-numbers', values).then(res => res.data)

export const getMichiganTitleFee = () =>
  apiClient.get<ApiResponse<SettingsMichiganTitleFeeDto>>('/api/settings/michigan-title-fee').then(res => res.data)

export const updateMichiganTitleFee = (values: SettingsMichiganTitleFeeDto) =>
  apiClient.put<ApiResponse<SettingsMichiganTitleFeeDto>>('api/settings/michigan-title-fee', values).then(res => res.data)

export const getQuickBooksSync = () =>
  apiClient.get<ApiResponse<QuickBooksSyncBootstrapDto>>('/api/settings/quickbooks-sync').then(res => res.data)

export const getQuickBooksSyncVersions = () =>
  apiClient.get<ApiResponse<QuickBooksSyncDto[]>>('/api/settings/quickbooks-sync/versions').then(res => res.data)

export const uploadQuickBooksSync = (values: QuickBooksSyncUploadDto) =>
  apiClient
    .post<ApiResponse<QuickBooksSyncBootstrapDto>>('/api/settings/quickbooks-sync', objectToFormData(values), {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(res => res.data)
